import { render, staticRenderFns } from "./UpdateSensor.vue?vue&type=template&id=2a76d1a6&"
import script from "./UpdateSensor.vue?vue&type=script&lang=js&"
export * from "./UpdateSensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports